<template>
  <div style="width: 100%; height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 80%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.auPhone" style="width: 140px;" size="small" placeholder="请输入手机号"
            clearable></el-input>
          <el-input v-model="formDatas.auName" style="width: 140px;" size="small" placeholder="请输入姓名"
            clearable></el-input>
          <!--选择部门  -->
          <el-select v-model="formDatas.adId" placeholder="请选择部门" size="small" style="width: 140px;" clearable
            @change="partserch">
            <el-option v-for="item in departmentArr" :key="item.adId" :label="item.adName" :value="item.adId">
            </el-option>
          </el-select>
          <el-select v-model="formDatas.auPost" placeholder="请选择岗位" size="small" style="width: 140px;" clearable
            @change="partserch">
            <el-option label="用户 " :value="1"></el-option>
            <el-option label="管理员" :value="2"></el-option>
            <!-- <el-option label="用户" :value="3"></el-option>
            <el-option label="背调员" :value="4"></el-option> -->
          </el-select>
          <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
          <!-- <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style="margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <el-button type="danger" size="small" style="" @click="
            dialog = true;
          edit = false;
          ">新增用户</el-button>
          <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" :max-height="tableHight"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none',
          }">
          <!-- @selection-change="handleSelectionChange" -->
          <!--  <el-table-column type="selection" width="55" >
          </el-table-column> -->

          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column prop="auName" label="用户姓名"> </el-table-column>
          <el-table-column prop="adName" label="用户部门"> </el-table-column>
          <el-table-column prop="auPhone" label="用户手机号"> </el-table-column>
          <el-table-column prop="auPost" label="用户岗位" width="120">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" disable-transitions>{{
                scope.row.auPost == 1 ? '用户' : scope.row.auPost == 2 ? '管理员' : ' '
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" width="160">
          </el-table-column>
          <el-table-column prop="dmDelete" label="用户状态" width="140">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.dmDelete == 2 ? 'danger' : 'success'" disable-transitions>{{
                scope.row.dmDelete == 2 ? "已删除" : "在使用" }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <!-- <el-button size="mini" type="text" @click="openBank(scope.row)">智能体权限</el-button> -->
              <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="handleDel(scope.row.auId)" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 100%;height: 60px">
        <div style="width: 100%;height: 100%;margin-top: 10px;">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 80, 100, 300, 500, 1000]" background layout="total,sizes,prev, pager, next "
            :page-size="20" :total="totals" :current-page="currentPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-drawer :title="edit == true ? '编辑用户' : '新增用户'" :wrapperClosable="false" :before-close="handleClose"
      :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content" style="padding: 50px">
        <el-form :model="form" label-position="top" :rules="rules">
          <el-form-item label="用户姓名" label-width="100">
            <el-input v-model="form.auName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户手机号" label-width="100" prop="auPhone">
            <el-input v-model="form.auPhone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户部门" label-width="100" prop="adId">
            <el-select v-model="form.adId" placeholder="请选择部门" style="width: 100%">
              <el-option v-for="item in departmentArr" :key="item.adId" :label="item.adName" :value="item.adId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户岗位" label-width="100" prop="auPost">
            <el-select v-model.number="form.auPost" placeholder="请选择岗位" :disabled="edit == true">
              <el-option label="用户 " :value="1"></el-option>
              <el-option label="管理员" :value="2"></el-option>
              <!-- <el-option label="用户" :value="3"></el-option>
              <el-option label="背调员" :value="4"></el-option> -->
            </el-select>
          </el-form-item>

          <el-form-item label="用户密码" label-width="100">
            <el-input v-model="form.auPw" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户描述" label-width="100">
          <el-input v-model="form.suDes" autocomplete="off"></el-input>
        </el-form-item> -->
        </el-form>
        <div class="demo-drawer__footer" style="margin-top: 50px">
          <el-button @click="cancelForm" style="margin-left: 50px">取 消</el-button>
          <el-button type="primary" @click="open" :loading="loading" style="margin-left: 150px">{{ loading ? "提交中 ..." :
            "确 定" }}</el-button>
        </div>
      </div>
    </el-drawer>
    <!--分配权限 -->
    <el-dialog title="分配权限" :visible.sync="IsAuth" width="70%" top="8vh" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="AuthHandleClose">
      <div style="width: 100%;display: flex;flex-direction: row-reverse;margin: 20px 0;">
        <el-button type="success" size="small" style="margin-right: 20px" @click="addAbout">新增关联</el-button>
      </div>
      <div>
        <ve-table ref="vetable2" v-if="AuthData" :columns="columnsAuth" :table-data="AuthData" :max-height="600"
          :border-x="true" :border-y="true" :scrollWidth="10" row-key-field-name="aamId" style="width: 100%" />
        <div v-show="AuthData.length == 0" class="empty-data">暂无数据</div>
      </div>
    </el-dialog>
    <el-dialog title="新增关联" :visible.sync="isAddBank" width="70%" top="8vh">
      <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
        <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
          <el-form-item label="智能体" prop="aaId">
            <el-select v-model="formBank.aaId" placeholder="请选择智能体">
              <el-option v-for="item in getAiAppList_data || []" :label="item.aaTitle" :value="item.aaId"
                :key="item.aaId">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="demo-drawer__footer" style="margin-top: 10px;">
        <el-button @click="handleClose2()" style="margin-left: 20%;">取 消</el-button>
        <el-button type="primary" @click="SureBtn2" style="margin-left: 150px;">
          确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
// import api from "../../utils/api";
import {
  getDepartmentList,
  deleteAiUser,
  addAiUser,
  getAiUserList,
  updateAiUser,
  getAiAuthModelListUser,
  getAiAppList,
  addAiAuthModelListUser,
  deleteAiAuthModel
} from "../../api/api";
export default {
  name: "userList",
  data() {
    return {
      departmentArr: [],
      isAddBank: false,
      formBank: {
        aaId: ''
      },
      getAiAppList_data: [],
      columnsAuth: [
        // {
        //     field: "",
        //     key: "checkbox",
        //     // type=checkbox
        //     type: "checkbox",

        //     title: "",
        //     width: 50,
        //     align: "center",
        // },
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "aaName",
          key: "aaName",
          title: "智能体",
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  <el-tag>{row.aaName}</el-tag>
                }
              </span>
            )
          },
        },
        { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button
                  size="mini"
                  type="text"
                  style="color: red"
                  on-click={() => this.handleDeleteAbout(row)}
                >
                  删除关联
                </el-button>
              </span>
            );
          },
        },
      ],
      AuthData: [],
      myRoleId: '',
      IsAuth: false,
      authTreeList: [],
      getAiAppList_data: [],
      atidsArr: [],
      currentPage: 1,
      tableHight: 720,
      watchFlag: false,
      windheight: "",
      tableData: [],
      dialog: false, //弹框
      loading: false,
      timer: null,
      form: {
        adId: 1,
        auPost: null,
        auPw: "",
        suDes: "",
        auName: "",
        auPhone: '',
      },
      formDatas: {
        currentPage: 1,
        pageSize: 20,
      },
      diashow: false, //关闭
      rules: {
        iuAccount: [
          {
            required: true,
            message: "请输入用户姓名",
            trigger: "blur",
          },
        ],
        auPost: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change",
          },
        ],
      },
      edit: false, //编辑时
      totals: null,
    };
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  methods: {
    AuthHandleClose() {
      this.IsAuth = false;
    },
    handleDeleteAbout(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAiAuthModel({ aamId: row.aamId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList2()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleClose2() {
      this.isAddBank = false;
      this.formBank = {
        aaId: '',

      }
      this.$refs['formRef'].resetFields();
    },
    openBank(row) {
      getAiAuthModelListUser({ auId: row.auId }).then(res => {
        this.AuthData = res.data;
        this.theRoleId = row.auId
        this.IsAuth = true;
      })
    },
    SureBtn2() {
      this.$confirm("是否确定要新增, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = JSON.parse(JSON.stringify(this.formBank))
          data.auId = this.theRoleId
          addAiAuthModelListUser(data).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "新增成功!",
              });
              this.handleClose2()
              this.getList2()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })

    },
    getList2() {
      getAiAuthModelListUser({ auId: this.theRoleId }).then(res => {
        this.AuthData = res.data;
      })
    },
    addAbout() {
      getAiAppList({ pageSize: 0 }).then(res => {
        this.getAiAppList_data = res.data;
        this.isAddBank = true;
      })
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.formDatas.pageSize = val;
      this.getAiUserListUser()
    },
    // 分页跳转
    async handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.formDatas.currentPage = val;
      const s = qs.stringify(this.formDatas)

      await getAiUserList(this.formDatas).then(res => {
        this.totals = res.total
        this.tableData = res.data
        this.$nextTick(() => {
          //console.log('最后的ids', this.atidsArr)
          this.tableData.forEach((i, index) => {
            this.atidsArr.forEach(t => {
              if (i.auId === t.auId) {
                this.$refs.multipleTable.toggleRowSelection(i, true);
              }
            })
          })
        })
      })
    },
    handleDel(val) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const s = qs.stringify({ auId: val });
          deleteAiUser(s).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getAiUserListUser();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑
    handleEdit(index, row) {
      //console.log(index, row);
      this.edit = true;
      this.dialog = true;
      this.form.auId = row.auId;

      this.form = row;
    },
    // 删除
    handleDelete(index, row) {
      //console.log(index, row);
    },
    // 获取列表
    getAiUserListUser() {
      this.$nextTick(() => {
        getAiUserList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totals = res.total
        });
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.currentPage = 1;
      getAiUserList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totals = res.total
      });
    },
    open() {
      if (this.form.iuAccount == "" || this.form.auPost == "") {
        this.$message({
          showClose: true,
          message: "请完成表单内容",
          type: "success",
        });
      } else {
        this.diashow = true;
        this.$refs.drawer.closeDrawer();
      }
    },
    handleClose(done) {
      //console.log(this.diashow);
      if (this.diashow == false) {
        this.$confirm("确认关闭？")
          .then((_) => {
            done();
          })
          .catch((_) => { });
        (this.form = {
          adId: 1,
          auName: "",
          iuAccount: "",
          auPost: null,
          auPw: "",
          suDes: "",
          auPhone: "",
        }),
          (this.edit = false);
        this.diashow = false;
      } else {
        //console.log(this.diashow);
        // 表单编辑
        if (this.edit == true) {
          this.$confirm("确定要编辑用户吗？")
            .then((_) => {
              const s = qs.stringify(this.form);
              updateAiUser(s).then((res) => {
                if (!res) return;
                this.getAiUserListUser();
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success",
                });
                (this.form = {
                  auName: "",
                  auPost: null,
                  auPw: "",
                  auPhone: "",
                  adId: 1,
                }),
                  // this.loading = true;
                  done();
                this.diashow = false;
              });

              // this.timer = setTimeout(() => {

              // 动画关闭需要一定的时间
              // setTimeout(() => {
              //   this.loading = false;
              // }, 400);
              // }, 2000)
            })
            .catch((_) => { });
        } else {
          // 表单提交
          this.$confirm("确定要提交表单吗？")
            .then((_) => {
              const s = qs.stringify(this.form);
              addAiUser(s).then((res) => {
                if (!res) return;
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                });
                this.getAiUserListUser();
                (this.form = {
                  auName: "",
                  adId: 1,
                  auPost: null,
                  auPw: "",
                  suDes: "",
                  auPhone: "",
                }),
                  // this.loading = true;
                  done();
                this.diashow = false;
              });

              // this.timer = setTimeout(() => {
              //   done();
              //   // 动画关闭需要一定的时间
              //   setTimeout(() => {
              //     this.loading = false;
              //   }, 400);
              // }, 2000)
            })
            .catch((_) => { });
          this.diashow = false;
        }
      }
    },
    // 表单取消
    cancelForm() {
      (this.form = {
        auName: "",
        adId: 1,
        auPost: null,
        auPw: "",
        suDes: "",
        auPhone: "",
      }),
        (this.edit = false);
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      this.getAiUserListUser();
    });
  },
  async created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    // 获取智能体
    getAiAppList({ pageSize: 0 }).then(res => {
      this.getAiAppList_data = res.data
    })
    getDepartmentList({ pageSize: 0 }).then((res) => {
      this.departmentArr = res.data;
    });
    // this.getAiUserListUser();
  },
};
</script>

<style scoped>
div /deep/ .el-pagination__total {
  margin-right: 35%;
  margin-left: 5%;
}
</style>
